import GovernmentIcon from './component'

export default GovernmentIcon
